enum DashboardComponentEnum {
    LMC_Dashboard = "LMC_Dashboard",
}

export default DashboardComponentEnum;
